export default __webpack_public_path__ + "static/media/crisil.a65e8160.png";